/**
 * セーブは IndexedDB でブラウザ内完結（§4.1）。
 * 保存するのは GameState をそのまま JSON 化したものだけ（§4.4）。
 */
import { GameState, deserialize, serialize } from '../sim/state';

const DB_NAME = 'the-cat-tower';
const STORE = 'saves';
const DB_VERSION = 1;

export const AUTO_SLOT = 'auto';

let dbPromise: Promise<IDBDatabase> | null = null;

function open(): Promise<IDBDatabase> {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
}

function tx<T>(mode: IDBTransactionMode, fn: (store: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  return open().then(
    (db) =>
      new Promise<T>((resolve, reject) => {
        const t = db.transaction(STORE, mode);
        const req = fn(t.objectStore(STORE));
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
      }),
  );
}

export async function saveSlot(slot: string, state: GameState): Promise<void> {
  await tx('readwrite', (s) => s.put(serialize(state), slot));
}

export async function loadSlot(slot: string): Promise<GameState | null> {
  try {
    const json = await tx<string | undefined>('readonly', (s) => s.get(slot));
    return json ? deserialize(json) : null;
  } catch {
    return null;
  }
}

export async function listSlots(): Promise<string[]> {
  try {
    const keys = await tx<IDBValidKey[]>('readonly', (s) => s.getAllKeys());
    return keys.map(String).sort();
  } catch {
    return [];
  }
}

export async function deleteSlot(slot: string): Promise<void> {
  await tx('readwrite', (s) => s.delete(slot));
}
